import SuperFetch from '../../superFetch.js';

class PointApi {
  /**
   *  [포인트 내역 리스트] 포인트 내역 리스트 요청하기
   */
  getPointList = (data) => SuperFetch.post('/point/list', data);

  /**
   *  [포인트 log 모달] 포인트 log 요청하기
   */
  getPointLog = (data) => SuperFetch.post('/point/log', data);

  /**
   *  [포인트 랭킹] 포인트 랭킹 리스트 요청하기
   */
  getPointRanking = (data) => SuperFetch.post('/point/ranking', data);

  /**
   *  [포인트 랭킹] 포인트 랭킹 리스트 엑셀 다운로드 요청하기
   */
  getPointRankingListExcelDownload = (data) => SuperFetch.post('/point/ranking/list/excel/download', data);

  /**
   * [포인트 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  getGenerateSearchUserList = (data) => SuperFetch.post('/point/generate/search/user', data);

  /**
   * [포인트 발급] 포인트 발급 전 준비 데이터 받아오기
   */
  getPreparationGeneratePoint = (data) => SuperFetch.post('/point/generate/preparation', data);

  /**
   * [포인트 일괄 발급] 엑셀 일괄 발급 유효성 체크 요청하기
   */
  excelBulkGeneratePointCheck = (data) => SuperFetch.post('/point/generate/bulk/check', data);

  /**
   *  [포인트 발급] 포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  getGenerateUserListExcelDownload = (data) => SuperFetch.post('/point/generate/list/user/excel/download', data);

  /**
   *  [포인트 발급 내역 리스트] 포인트 발급 내역 리스트 요청하기
   */
  getPointIssueHistoryList = (data) => SuperFetch.post('/point/issueHistory/list', data);

  /**
   * [포인트 발급 내역 상세] 포인트 발급 내역 상세 가져오기
   */
  getPointIssueHistoryDetail = (data) => SuperFetch.post('/point/issueHistory/detail', data);

  /**
   *  [포인트 발급 내역 상세] 포인트 로그 리스트 가져오기
   */
  getPointLogList = (data) => SuperFetch.post('/point/issueHistory/detail/pointLog/list', data);

  /**
   *  [레퍼럴 발급 현황] 레퍼럴 발급 리스트 가져오기
   */
  getPointReferralIssueList = (data) => SuperFetch.post('/point/referralIssue/list', data);

  /**
   *  [포인트 사유 리스트] 포인트 사유 리스트 가져오기
   */
  getPointCauseList = (data) => SuperFetch.post('/point/cause/list', data);

  /**
   *  [포인트 사유 등록] 포인트 사유 등록하기
   */
  createPointCause = (data) => SuperFetch.post('/point/cause/create', data);
}

export default new PointApi();
